
(function ($, d, w, f, ns) {
    ns.initScrollListener = function () {
        $(w).on('scroll', f.throttle(
            function (e) {
                if (f.is_large_up()) {
                    if ($(d).scrollTop()) {
                        $('.header--wrap').addClass('scrolled');
                        $('.header--padding').addClass('scrolled');
                    } else {
                        $('.header--wrap').removeClass('scrolled');
                        $('.header--padding').removeClass('scrolled');
                    }

                    if (typeof intro !== 'undefined') {
                        intro.refresh();
                    }                    
                }
            }, 100));
    };


    $(d).ready(function () {
        ns.initScrollListener();
    });


})(jQuery, document, window, Foundation.utils, Crafted.Utilities);